<template>
	<v-container fluid id="authContainer" class="d-flex justify-center align-end">
		<div id="closeBtn">
			<v-btn @click='$emit("close")' large tile><v-icon left>mdi-close</v-icon> Close</v-btn>
		</div>

		<amplify-authenticator>
			<amplify-sign-in
				header-text="PRIMAR Authentication"
				slot="sign-in"
				:hide-sign-up="true"
			></amplify-sign-in>
		</amplify-authenticator>
	</v-container>
</template>

<script>
export default {
	name: 'AmplifyAuthentication'
}
</script>

<style lang="stylus" scoped>
#authContainer
	position fixed
	z-index 999
	padding-top 20vh
	background-color rgba(0, 0, 0, 0.5)

#closeBtn
	position absolute
	right 10px
	top 10px
	z-index 1000
</style>